import { IBrushSettings } from "../models/brush.ts";

export const MAX_ALLOWED_SELECTED_IMAGES = 35;
export const DEFAULT_BRUSH: IBrushSettings = Object.freeze({
	lineJoin: "round",
	lineCap: "round",
	strokeStyle: "#8800FF",
	lineWidth: 60,
	globalCompositeOperation: "source-over",
	globalAlpha: 1,
	brushColorOpacity: 0.5,
	reset: false,
});

export const SOLID_COLOR_CONFIG = {
	selected: false,
	color_code: "#FFFFFF",
};

export const GENERATE_BY_TEXT_CONFIGS = {
	selected: false,
	prompt: "",
	num_results: 4,
	fast_version: false,
};

export const GENERATE_BY_IMAGE_CONFIGS = {
	selected: false,
	ref_image_url: "",
	num_results: 4,
};

export const DEFAULT_BACKGROUND_CONFIGS = {
	expand: false,
	remove: false,
	solid: SOLID_COLOR_CONFIG,
	generateByText: GENERATE_BY_TEXT_CONFIGS,
	generateByImage: GENERATE_BY_IMAGE_CONFIGS,
};

export const CUSTOM_SIZE_CONFIGS = {
	selected: false,
	width: 0,
	height: 0,
};

export const DEFAULT_SIZE_CONFIGS = {
	crop: false,
	custom_size: CUSTOM_SIZE_CONFIGS,
};

export enum SegmentationMaskTypes {
	AUTOMATIC = "automatic",
	MANUAL = "manual",
}

export const OBJECT_MANIPULATION_CONFIGS = {
	prompt: "",
	num_results: 4,
	erase: false,
	gen_fill: false,
	mask_type: SegmentationMaskTypes.MANUAL,
};

export enum ConfigOptions {
	REMOVE = "remove",
	SOLID = "solid",
	EXPAND = "expand",
	BLUR = "blur",
	GENERATE_BY_TEXT = "generateByText",
	GENERATE_BY_IMAGE = "generateByImage",
	CROP = "crop",
	CUSTOM_SIZE = "custom_size",
	MEDIUM_DESTINATION = "medium_destination",
}

export const MAX_THUMBNAIL_IMAGES = 13;
